import { UnderConstruction } from '@/components/organisms'

export const InvoiceData = () => {
    return <UnderConstruction />
}
